import PropTypes from 'prop-types';

/**
 * @typedef {Object} Image
 * @property {string|null} [caption]
 * @property {string} [small]
 * @property {string} [medium]
 * @property {string} [large]
 * @property {string} [original]
 */
const Image = {
  caption: PropTypes.string,
  small: PropTypes.string,
  medium: PropTypes.string,
  large: PropTypes.string,
  original: PropTypes.string,
};

export default Image;
